import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaAngleRight } from 'react-icons/fa';
import pdf from '../images/collection-pdf.png';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { Helmet } from 'react-helmet-async';
import SakrebuloActs from './SakrebuloActs';
import SakrebuloActsList from './SakrebuloActsList';
function SakrebulosKonkursebi() {
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [actList, setActList]= useState('')


	const [menu, setMenu] = useState({});
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				// console.log('data.menu',data.menu)
				setMenu(data.menu);

				//  console.log('menu', menu)

				//  console.log('object entries', Object.entries(menu))

				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
						//console.log('entries item', item[1].name_eng , item[1].level)
					}
				});
			});
	}, []);
	
	const menuName = Object.entries(menu).length
		? Object.entries(menu).find((item, index) => {
				const windoww = window.location.pathname;
				const result = windoww.split('/').pop();
				const slugg = item[1].slug;
				if (result === slugg) {
					return language == 1 ? item[1].name_geo : item[1].name_eng;
				}
		  })
		: '';

	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});

	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{language == 1 ? 'სამართლებრივი აქტები' : 'LEGAL ACTS'}
					</span>

					<span>
						{menuName[1]
							? language == 1
								? menuName[1].name_geo
								: menuName[1].name_eng
							: ''}
					</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
							<div className='sajaroInfo '>
								<SakrebuloActs actsSlug={actList? actList : 'konkursebi'} />
							</div>
						</div>
					</div>
						<div className='presscenter-info'><SakrebuloActsList setActList={setActList}/></div>
				</div>
			</div>
		</motion.div>
	);
}

export default SakrebulosKonkursebi;
